import * as xlsx from "xlsx";

type FileType = xlsx.ParsingOptions["type"];

export default class ExcelManager {
    static read<T = any>(buffer: ArrayBuffer, type: FileType = "buffer"): T[] {
        const wb = xlsx.read(buffer, { type });
        return xlsx.utils.sheet_to_json<any>(wb.Sheets[wb.SheetNames[0]], { defval: "" });
    }

    static write(data: any[], fileName: string = "filename.xlsx"): ArrayBuffer {
        const wb = xlsx.utils.book_new();
        const ws = xlsx.utils.json_to_sheet(data, { skipHeader: true });
        xlsx.utils.book_append_sheet(wb, ws);
        return xlsx.writeFile(wb, fileName);
    }
}
